<template>
  <div>
        <span @dblclick="show" v-show="!show_form" style="cursor:pointer">
            {{ vat }}
        </span>

    <div v-show="show_form">
      <div class="form-group">
        <select class="form-control" v-model="edited_vat">
          <option v-for="vat in available_vats">{{ vat }}</option>
        </select>
      </div>
      <button @click="updateHistoryItem"
              class="btn btn-primary"
              v-text="trans('update_button', null)"
      ></button>
    </div>
  </div>
</template>

<script>
let Functions = require("../../Functions");

export default {
    props: ['state_item_id', 'current_route', 'translations', 'available_vats', 'vat'],
    data: function () {
      return {
        'show_form': false,
        'edited_vat': this.vat
      };
    },
    mounted: function() {
      Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
    },
    methods: {
      trans(name, path = 'stock') {
        return Functions.trans(this.translations, name, path);
      },
      show: function () {
        this.show_form = true;
      },
      updateHistoryItem: function () {
        this.$http.post(this.current_route + '/update', {
          id: this.state_item_id,
          vat: this.edited_vat
        }).then(() => {
          this.show_form = false;
          this.$root.$emit('update-table');
        });
      },
    },
}
</script>
